import { ProductTypes } from '../../types/product/product';
import { FilterTypes } from '../../store/reducers/productFilter.reducer';

export const isCheaperThanPrice = (
  price: FilterTypes['price']
): Predicate<ProductTypes> => product => product.ttcPrice <= price;
